export default __webpack_public_path__ + "static/sub1.1_Valery-f0f2cf6d59e2ddf954f6b677a0f66782.wav";